<template>
    <div class="warning">
        <i class="material-icons mr-2">warning</i>
        <span>
            <slot></slot>
        </span>
    </div>
</template>
<script>
export default {
    name: "Warning",
};
</script>
<style lang="scss" scoped>
.warning {
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 5px;
    background: #0d1d30;
    color: white;
    font-size: 14px;
    i {
        font-size: 16px;
    }
}
</style>